export default "__VITE_ASSET__BIXtgbsN__"